/* eslint-disable camelcase */
export default {
  alphabet: 'alphabet-magnets',
  face: 'face',
  gingerbread: 'gingerbread-house',
  pumpkin: 'pumpkin',
  snowman: 'snowman'
};
